<template>
  <section>
    <loading-flux :value="loading"></loading-flux>
    <v-dialog
      v-model="modalAction"
      max-width="800px"
      scrollable
      @keydown="executeCloseModalAddUserRestriction"
      @click:outside="executeCloseModalAddUserRestriction"
    >
      <v-card>
        <div class="p-4 pb-0">
          <h5>
            Agregar Usuario a Listado de Visualización de Documentos
          </h5>
        </div>
        <hr />
        <v-card-text>
          <v-container class="">
            <v-form @submit.prevent="sendAddUserRestrictionDocuments">
              <v-row align-content="center" class="">
                <v-col cols="12" md="12" sm="12">
                  <v-autocomplete
                    :items="wrappedEmployees"
                    v-model="$v.form.user_email.$model"
                    item-text="label"
                    item-value="email"
                    :filter="customFilter"
                    @update:search-input="
                      $event !== null ? getEmployeesData($event) : null
                    "
                    :loading="loadingEmployees"
                    searchable
                    label="Usuario a seleccionar"
                    placeholder="Selecciona un usuario"
                    hide-details
                    no-data-text="No hay usuarios para mostrar"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            outlined
            @click="executeCloseModalAddUserRestriction"
          >
            <small> Cancelar </small>
          </v-btn>
          <v-btn
            @click="sendAddUserRestrictionDocuments"
            :color="`primary text-white`"
            small
            class="float-right"
          >
            <v-icon x-small class="mr-1">
              mdi-account-plus
            </v-icon>
            Asignar Usuario
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { authUsuarioComputed } from "@/state/helpers";
import { preventCloseIfNotKeyEventEsc } from "@/helpers/common";
import { required } from "vuelidate/lib/validators";
import swal2 from "sweetalert2";
import config from "@/config";

export default {
  props: {
    modalAction: {
      type: Boolean,
      default: false,
    },
    closeModalAddUserRestriction: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      loadingEmployees: false,
      debounce: null,
      debounceTime: 500,
      form: {
        user_email: null,
      },
      submitUpload: false,
    };
  },
  validations() {
    return {
      form: {
        user_email: { required },
      },
    };
  },
  mounted() {
    this.getEmployeesData();
  },
  methods: {
    ...mapActions({
      changeUserRestrictionDocuments: "document/changeUserRestrictionDocuments",
      getEmployees: "maintainers/getSubstituteEmployees",
    }),
    async getEmployeesData(search = "") {
      if (search === null || !search.includes("(")) {
        clearTimeout(this.debounce);
        let self = this;
        this.debounce = await setTimeout(async function() {
          self.loadingEmployees = true;
          await self.getEmployees({
            password: config.password_manteiners,
            page: 0,
            filter: search ?? undefined,
            document_viewer: false,
          });
          self.loadingEmployees = false;
        }, self.debounceTime);
      }
    },
    customFilter(item, queryText, itemText) {
      const text = itemText.toLowerCase();
      const words = queryText.toLowerCase().split(/\s+/);

      // Devuelve true si todas las palabras están en el texto
      return words.every((word) => text.includes(word));
    },

    async sendAddUserRestrictionDocuments() {
      let self = this;
      self.submitUpload = true;
      if (!self.$v.form.$invalid) {
        self.loading = true;
        const resp = await self.changeUserRestrictionDocuments({
          email: self.form.user_email,
          document_viewer: true,
        });
        if (resp?.status == 200) {
          swal2.fire({
            icon: "success",
            title: "Excelente",
            text:
              "Usuario agregado a visualización de documentos correctamente",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 5000,
            timerProgressBar: true,
          });
          this.$emit("userAdded");
          this.closeModalAddUserRestriction(true);
          this.resetForm();
        }
        if (!resp.status || resp.status === 400) {
          self.loading = false;
          return swal2.fire({
            icon: "error",
            title: "Error",
            text: resp.data.detail,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 10000,
            timerProgressBar: true,
          });
        }
        this.loading = false;
      }
    },
    executeCloseModalAddUserRestriction($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.resetForm();
        this.closeModalAddUserRestriction($event);
      }
    },
    resetForm() {
      this.form = {
        user_email: null,
      };
      this.submitUpload = false;
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({
      employees: "maintainers/substituteEmployees",
    }),
    wrappedEmployees() {
      return this.employees.employees.map((item) => {
        return {
          label: `${item.full_name} (${item.email})`,
          ...item,
        };
      });
    },
  },
};
</script>

<style></style>
